'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.businessSystem', [])

.factory('businessSystemService', ['$http', '$q', function ($http, $q) {

    var service = {};

    // For Models System Role
    service.systemRole = {};

    service.systemRole.bySystemDict = function (systemRoles) {
        return _.groupBy(systemRoles, 'SystemID');
    }

    service.systemRole.bySystem = function (systemRoles) {
        var bySystemsDict = service.systemRole.bySystemDict(systemRoles);
        var bySystems = [];

        Object.keys(bySystemsDict).forEach(function (systemID) {
            var sysRoles = bySystemsDict[systemID];
            bySystems.push({
                System: sysRoles[0],
                SystemRoles: _.sortBy(sysRoles, 'SystemRoleName')
           });
        });

        return _.sortBy(bySystems, function (sys) { return sys.System.SystemName; });
    }

    // Systems
    service.getBusinessSystemForCard = function (systemId) {
        return $http.get(environment.apiUrl + '/ID/API/System/' + systemId + '/ForSearch',
                         { cache: true })
                    .then(function (response) {
                        return response.data;
                    });
    }

    // System Owner
    service.addNewBackupSystemOwner = function (systemId, backupEmployeeId) {
        return $http.post(environment.apiUrl + '/ID/Administration/System/API/' + systemId + '/SystemOwner/Backup/' + backupEmployeeId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.removeBackupSystemOwner = function (systemId, backupEmployeeId) {
        return $http.delete(environment.apiUrl + '/ID/Administration/System/API/' + systemId + '/SystemOwner/Backup/' + backupEmployeeId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.changePrimarySystemOwner = function (systemId, newPrimaryEmployeeId) {
        return $http.post(environment.apiUrl + '/ID/Administration/System/API/' + systemId + '/SystemOwner/Primary/' + newPrimaryEmployeeId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // System Roles
    service.getActiveSystemRolesByBusinessSystem = function (systemId) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/Active/BySystem/' + systemId,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSystemRolesByBusinessSystem = function (systemId) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/BySystem/' + systemId,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSystemRolesByEmployee = function (employeeId) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/ByEmployee/' + employeeId,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getAllowableSystemRolesByRequestAndSystemType = function (userAccessRequestId, systemTypeId) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/Allowable' +
                         '/BySystemTypeID/' + systemTypeId +
                         '/ByRequestID/' + userAccessRequestId,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getAllowableSystemRolesByRequest = function (userAccessRequestId) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/Allowable' +
                         '/ByRequestID/' + userAccessRequestId,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getDefaultEntitlementByRequest = function (userAccessRequestId) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/DefaultEntitlement' +
                         '/ByRequestID/' + userAccessRequestId,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.searchOthersSystemRolesByRequest = function (userAccessRequestId, searchTerm) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/Other' +
                         '/ByRequestID/' + userAccessRequestId +
                         '?searchTerm=' + searchTerm,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.searchOthersSystemRolesByRequestAndSystemType = function (userAccessRequestId, systemTypeId, searchTerm) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/Other' +
                         '/BySystemTypeID/' + systemTypeId +
                         '/ByRequestID/' + userAccessRequestId +
                         '?searchTerm=' + searchTerm,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getPrivilegesForSystemRole = function (systemRoleId) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/' + systemRoleId + '/Privileges',
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Employees
    service.getEmployeesBySystemRole = function (systemRoleId) {
        return $http.get(environment.apiUrl + '/ID/API/SystemRole/' + systemRoleId + '/Employees',
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // System Types
    service.getSystemTypes = function () {
        return $http.get(environment.apiUrl + '/ID/API/SystemType', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSystemTypeBySlug = function (slug) {
        return $http.get(environment.apiUrl + '/ID/API/SystemType/BySlug/' + slug, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Custodians
    service.getAllCustodians = function () {
        return $http.get(environment.apiUrl + '/ID/API/Custodian', {cache: true})
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
